<app-loader [loading]="expectedMedicalDocsAreLoading" [fullPage]="true" [title]="'chargement'"></app-loader>

<section *ngIf="!expectedMedicalDocsAreLoading" class="simulation grid-container grid-container--section no-gutter-mobile">
    <div>
        <form method="POST" novalidate="" enctype="multipart/form-data">
            <fieldset class="simulation__step" data-ng-form="adhesionForm" name="adhesionForm">
                <legend style="display: none">
                    {{ 'next-step-introduction.header.description' | i18n }}
                </legend>
                <!-- uiView: adhesionSteps -->
                <div data-ui-view="adhesionSteps">
                    <section class="document-selection">
                        <!-- ngIf: documentSelection.isBasicLayout() -->
                        <div class="simulation__group" data-ng-if="documentSelection.isBasicLayout()">
                            <!-- uiView: documentStep -->
                            <div cand-scroll-error="" data-ui-view="documentStep" autoscroll="false">
                                <section class="grid-container next-step-introduction">
                                    <div class="grid-12">
                                        <div class="next-step-introduction__title">
                                            {{ 'next-step-introduction.header.description' | i18n }}
                                        </div>
                                        <div class="next-step-introduction__descriptions">
                                            <div class="next-step-introduction__descriptions__description">
                                                <img
                                                    alt=""
                                                    class="next-step-introduction__descriptions__description__icon next-step-introduction__descriptions__description__icon--heart"
                                                    data-cand-image="assets/images/icon-heart-health.svg"
                                                    [appAssetSrc]="'assets/images/icon-heart-health.svg'"
                                                />
                                                <div>
                                                    {{ 'nextstepintroduction.header.description.fee' | i18n }}
                                                </div>
                                            </div>
                                            <div class="next-step-introduction__descriptions__description">
                                                <img alt="" class="next-step-introduction__descriptions__description__icon" data-cand-image="assets/images/icon-information.svg" [appAssetSrc]="'assets/images/icon-information.svg'" />
                                                <div>
                                                    {{ 'nextstepintroduction.header.description.fee.details' | i18n }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <app-medical-docs-download-block-component (download)="downloadFile(expectedMedicalDocs)" [downloadDescription]="'nextstepintroduction.download.description'"> </app-medical-docs-download-block-component>
                                    <div class="grid-12">
                                        <div class="grid-container next-step-introduction__method">
                                            <div class="grid-12">
                                                <div class="next-step-introduction__method-title">
                                                    {{ 'nextstepintroduction.content.import.text' | i18n }}
                                                </div>
                                            </div>
                                            <div class="grid-4">
                                                <div class="next-step-introduction__method-item">
                                                    <div class="next-step-introduction__method-item_icon next-step-introduction__method-item_icon--monitor"></div>
                                                    <div class="next-step-introduction__method-item_label">
                                                        {{ 'nextstepintroduction.content.import.pc' | i18n }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="grid-4">
                                                <div class="next-step-introduction__method-item">
                                                    <div class="next-step-introduction__method-item_icon next-step-introduction__method-item_icon--phone"></div>
                                                    <div class="next-step-introduction__method-item_label">
                                                        {{ 'nextstepintroduction.content.import.mobile' | i18n }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="grid-4">
                                                <div class="next-step-introduction__method-item">
                                                    <div class="next-step-introduction__method-item_icon next-step-introduction__method-item_icon--message"></div>
                                                    <div class="next-step-introduction__method-item_label">
                                                        {{ 'nextstepintroduction.content.import.post' | i18n }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="grid-12 next-step-introduction__back-button">
                                        <button type="button" class="button button--primary" (click)="handleCloseClick()">
                                            {{ 'global.close' | i18n }}
                                        </button>
                                    </div>

                                    <app-send-docs-by-post-component></app-send-docs-by-post-component>
                                </section>
                            </div>
                        </div>
                        <!-- end ngIf: documentSelection.isBasicLayout() -->

                        <!-- ngIf: !documentSelection.isBasicLayout() -->
                    </section>
                </div>
            </fieldset>
        </form>
    </div>
</section>
